import { HTTPMethods } from '../../../yoello-lib/modules/API/API';
import { ANALYTICS_DASHBOARD_URL, NO_VENUES, VENUES } from '../../../const/URL.const';
import merchantAPIDefs from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from '../../../yoello-lib/modules/API2/useAPIv2';
// import { useAuth0 } from '../../../yoello-lib/modules/auth/Auth0';
// import { Auth0UserProfile } from 'auth0-js';
import { OnboardingSources } from '../../../components/signup/types';
import { useHistory } from 'react-router';
import { useState } from 'react';
import useSendSnackbar from '../../../hooks/useSendSnackbar';
import { useAuthenticationContext } from '../../../yoello-lib/modules/auth/AuthenticationContext';
import setRedirectURLs from "../../../yoello-lib/modules/URL/setRedirectURLs"

interface MerchantDTO {
    data: {
        id: string;
    }
}

export interface InvitationsDTO {
    data: Object[];
}

export interface IMerchantDetails {
    first_name: string,
    last_name: string,
    contact_email: string,
    contact_phone?: string,
    onboarding_source?: OnboardingSources
}

const useUserMerchantForm = () => {
    
    const { currentUser } = useAuthenticationContext();
    const history = useHistory();

    const { sendSnackbar } = useSendSnackbar();

    const { callAPI } = useAPIV2(merchantAPIDefs.invitations, {
        onMountDisabled: true
    });

    const [isLoading, setIsLoading] = useState(false);

    const createMerchant = (merchant: IMerchantDetails) => {
        return callAPI(HTTPMethods.POST, {
            body: merchant
        })
    }

    const checkForInvitations = (merchantId: string) => {
        return callAPI(HTTPMethods.GET, {
            query: `${merchantId}/venues/invitations`
        })
    }

    const acceptInvitations = (merchantId: string) => {
        return callAPI(HTTPMethods.POST, {
            query: `${merchantId}/venues/invitations/accept`
        })
    }

    const onSubmit = async (data: any) => {
        setIsLoading(true);
        const formattedMerchant = {
            first_name: data.first_name!,
            last_name: data.last_name!,
            contact_email: currentUser?.username!,
            onboarding_source: OnboardingSources.partners,
            language_code: "EN"
        }
        try {
            const merchant = await createMerchant(formattedMerchant) as MerchantDTO;
            const invitations = await checkForInvitations(merchant.data.id) as InvitationsDTO;

            if (invitations.data.length <= 0) {
                history.push(NO_VENUES);
                return;
            }
            await acceptInvitations(merchant.data.id);
            setRedirectURLs(ANALYTICS_DASHBOARD_URL)
            history.push(VENUES);
        } catch (e) {
            sendSnackbar("errors.api.createMerchant", "error")
        } finally {
            setIsLoading(false);
        }
    }
    return {
        onSubmit,
        isLoading
    }
}

export default useUserMerchantForm;